import React from "react";
import "./pushSettingToggle.scss";

/**
 * Push notification toggle component
 * @param {string} label - Toggle label text
 * @param {boolean} checked - Toggle state
 * @param {function} onChange - Toggle change handler
 * @param {boolean} disabled - Toggle disabled state
 */
const PushSettingToggle = ({ label, checked, onChange, disabled = false }) => {
    return (
        <div className="push-setting-toggle">
            <span className="toggle-label">{label}</span>
            <label className="toggle-switch">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span className="toggle-slider"></span>
            </label>
        </div>
    );
};

export default PushSettingToggle;
